/**
 * App.jsx
 * ---------------------------------------------------------------------------
 * Top-level composition. Mounts the navigation plus a router. Currently
 * routes:
 *   /                               → Home (the original single-page site)
 *   /coconsolex/*                   → CoConsoleX section (15 subtabs)
 */

import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Nav from "./components/sections/Nav.jsx";
import Home from "./routes/Home.jsx";
import CoConsoleXLayout from "./components/coconsolex/CoConsoleXLayout.jsx";
import Overview from "./components/coconsolex/pages/Overview.jsx";
import WhyItMatters from "./components/coconsolex/pages/WhyItMatters.jsx";
import WhoItServes from "./components/coconsolex/pages/WhoItServes.jsx";
import IdentityAccess from "./components/coconsolex/pages/IdentityAccess.jsx";
import MatterSegregation from "./components/coconsolex/pages/MatterSegregation.jsx";
import LitigationHold from "./components/coconsolex/pages/LitigationHold.jsx";
import OutputVerification from "./components/coconsolex/pages/OutputVerification.jsx";
import BackupContinuity from "./components/coconsolex/pages/BackupContinuity.jsx";
import HardwareLifecycle from "./components/coconsolex/pages/HardwareLifecycle.jsx";
import InsuranceRisk from "./components/coconsolex/pages/InsuranceRisk.jsx";
import AuditExamination from "./components/coconsolex/pages/AuditExamination.jsx";
import CrossBorder from "./components/coconsolex/pages/CrossBorder.jsx";
import EngagementSunset from "./components/coconsolex/pages/EngagementSunset.jsx";
import MidMarketEquity from "./components/coconsolex/pages/MidMarketEquity.jsx";
import ValidationProcurement from "./components/coconsolex/pages/ValidationProcurement.jsx";

import { tokens } from "./lib/tokens.js";

export default function App() {
  return (
    <BrowserRouter>
      <div style={{ background: tokens.bg, color: tokens.ink, minHeight: "100vh" }}>
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/coconsolex" element={<CoConsoleXLayout />}>
            <Route index element={<Overview />} />
            <Route path="why-it-matters" element={<WhyItMatters />} />
            <Route path="who-it-serves" element={<WhoItServes />} />
            <Route path="identity-access" element={<IdentityAccess />} />
            <Route path="matter-segregation" element={<MatterSegregation />} />
            <Route path="litigation-hold" element={<LitigationHold />} />
            <Route path="output-verification" element={<OutputVerification />} />
            <Route path="backup-continuity" element={<BackupContinuity />} />
            <Route path="hardware-lifecycle" element={<HardwareLifecycle />} />
            <Route path="insurance-risk" element={<InsuranceRisk />} />
            <Route path="audit-examination" element={<AuditExamination />} />
            <Route path="cross-border" element={<CrossBorder />} />
            <Route path="engagement-sunset" element={<EngagementSunset />} />
            <Route path="mid-market-equity" element={<MidMarketEquity />} />
            <Route path="validation-procurement" element={<ValidationProcurement />} />
          </Route>
        </Routes>
      </div>
    </BrowserRouter>
  );
}
